import { Stack, Typography, Alert } from "@mui/material"
import { ReactNode } from "react"

export const RenderWithWarning = (text: string, warning: string): ReactNode => (
    <Stack spacing={1}>
        <Typography>{text} </Typography>
        <Alert severity="warning"> {warning} </Alert>
    </Stack>
)
